import {
  coralogixEnvironmentFrom,
  rumApplicationNameFor
} from "./chunk-GDUMMQAD.js";

// src/browser/browser-telemetry.ts
import { CoralogixRum } from "@coralogix/browser";
function startBrowserTelemetry(params) {
  if (started) {
    return true;
  }
  const { component, environment, version, tracingUrls } = params;
  const publicKey = params.publicKey.trim();
  if (!publicKey) {
    return false;
  }
  const tracingUrlPatterns = tracingUrls.map(tracingUrlPatternFrom);
  try {
    CoralogixRum.init({
      application: rumApplicationNameFor(component),
      environment: coralogixEnvironmentFrom(environment),
      public_key: publicKey,
      coralogixDomain: "EU2",
      version,
      traceParentInHeader: {
        enabled: true,
        options: {
          allowedTracingUrls: tracingUrlPatterns,
          propagateTraceHeaderCorsUrls: tracingUrlPatterns
        }
      }
    });
    started = true;
    return true;
  } catch (error) {
    console.warn("Browser telemetry failed to start", error);
    return false;
  }
}
function setBrowserTelemetryIdentity(identity) {
  if (!started) {
    return;
  }
  try {
    CoralogixRum.setUserContext({ user_id: identity.userId, user_name: "" });
    if (identity.realm !== void 0) {
      CoralogixRum.setLabels({ realm: identity.realm });
    }
  } catch (error) {
    console.warn("Browser telemetry failed to set identity", error);
  }
}
function tracingUrlPatternFrom(baseUrl) {
  const escapedBaseUrl = baseUrl.replace(/\/+$/, "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return new RegExp(`^${escapedBaseUrl}(?:[/?#]|$)`, "i");
}
var started = false;
export {
  setBrowserTelemetryIdentity,
  startBrowserTelemetry
};
//# sourceMappingURL=browser.js.map